import { render, staticRenderFns } from "./RegistrationStepper.vue?vue&type=template&id=26906def&scoped=true"
import script from "./RegistrationStepper.vue?vue&type=script&lang=ts"
export * from "./RegistrationStepper.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationStepper.vue?vue&type=style&index=0&id=26906def&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26906def",
  null
  
)

/* custom blocks */
import block0 from "./registration.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2FRegistrationStepper.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./registration.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3399026096%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2Fregistration%2FRegistrationStepper.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports